import store from '@/store'
export default [
  {
    path: '/sub-programs',
    name: 'sub-program',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sub-program/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('subProgram/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/sub-programs/:id',
    name: 'sub-program-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sub-program/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('subProgram/dataBeforeCreate')
      let response = await store.dispatch('subProgram/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
